export default __webpack_public_path__ + "static/media/Captain's Armguards of Heaven's Pass.2c4e90be.jpg";